import React from "react";
import "./AskingServices.css";
import BubbleSvgButton from "../../BubbleSvgButton/BubbleSvgButton";

const AskingServices = ({ handleNext, setCommingFor }) => {
  return (
    <div className="tutorialContentBox askingServicesContentBox">
      <p className="title">What service do you want?</p>
      <p className="desc">
        You can always add the other service later on if needed.
      </p>
      <div>
        <BubbleSvgButton
          className="tutorialNextBtn"
          onClick={() => {
            setCommingFor("Launch Your Own Copy Trade");
            handleNext("Launch Your Own Copy Trade");
          }}
          text={"Launch Your Own Copy Trade"}
          type="button"
          variant="black"
          containerStyling={{
            justifyContent: "center",
          }}
          mainDivStyle={{
            width: "auto",
            height: "auto",
            marginBottom: "10px",
          }}
        />
        <BubbleSvgButton
          className="tutorialNextBtn"
          onClick={() => {
            setCommingFor("Verify Your Trading");
            handleNext("Verify Your Trading");
          }}
          text={"Verify Your Trading"}
          type="button"
          variant="black"
          containerStyling={{
            justifyContent: "center",
          }}
          mainDivStyle={{
            width: "auto",
            height: "auto",
          }}
        />
      </div>
    </div>
  );
};

export default AskingServices;
